module.exports = __webpack_public_path__ + "img/京津冀全数据.b393b0c6.png";